interface NetWorthInput {
  assets: {
    cash: number
    investments: number
    property: number
    vehicles: number
    other: number
  }
  liabilities: {
    mortgage: number
    studentLoans: number
    autoLoans: number
    creditCards: number
    other: number
  }
}

export function calculateNetWorth(input: NetWorthInput) {
  const totalAssets = Object.values(input.assets).reduce((s, v) => s + v, 0)
  const totalLiabilities = Object.values(input.liabilities).reduce((s, v) => s + v, 0)
  const netWorth = totalAssets - totalLiabilities

  const debtToAssetRatio = totalAssets > 0 ? totalLiabilities / totalAssets : 0

  // Asset allocation for chart
  const assetAllocation = [
    { name: 'Cash & Savings', value: input.assets.cash, color: '#22d3ee' },
    { name: 'Investments', value: input.assets.investments, color: '#2dd4bf' },
    { name: 'Property', value: input.assets.property, color: '#3b82f6' },
    { name: 'Vehicles', value: input.assets.vehicles, color: '#fbbf24' },
    { name: 'Other Assets', value: input.assets.other, color: '#a78bfa' },
  ].filter(a => a.value > 0)

  const liabilityBreakdown = [
    { name: 'Mortgage', value: input.liabilities.mortgage, color: '#fb7185' },
    { name: 'Student Loans', value: input.liabilities.studentLoans, color: '#f97316' },
    { name: 'Auto Loans', value: input.liabilities.autoLoans, color: '#fbbf24' },
    { name: 'Credit Cards', value: input.liabilities.creditCards, color: '#ef4444' },
    { name: 'Other Debt', value: input.liabilities.other, color: '#a78bfa' },
  ].filter(l => l.value > 0)

  // Health indicators
  let healthStatus: string
  let healthColor: string
  if (debtToAssetRatio === 0 && totalAssets > 0) {
    healthStatus = 'Debt-Free'
    healthColor = 'positive'
  } else if (debtToAssetRatio < 0.3) {
    healthStatus = 'Healthy'
    healthColor = 'positive'
  } else if (debtToAssetRatio < 0.5) {
    healthStatus = 'Moderate'
    healthColor = 'warning'
  } else if (debtToAssetRatio < 0.8) {
    healthStatus = 'High Leverage'
    healthColor = 'warning'
  } else {
    healthStatus = 'Over-Leveraged'
    healthColor = 'negative'
  }

  return {
    totalAssets: Math.round(totalAssets),
    totalLiabilities: Math.round(totalLiabilities),
    netWorth: Math.round(netWorth),
    debtToAssetRatio: Math.round(debtToAssetRatio * 1000) / 10,
    assetAllocation,
    liabilityBreakdown,
    healthStatus,
    healthColor,
    isPositive: netWorth >= 0,
  }
}
